import { ClearButtonBehaviour, DateInput } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { MonthYearFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';

interface Props extends Pick<TFormControlConnectorProps, 'areHintsShown'> {
  control: MonthYearFormControlViewModel;
  onSubmit?: (value: Date | null) => void;
  onChange?: (value: Date | null) => void;
  onChanged?: (value: Date | null) => void;
}

const setFirstOrLastDay = (value: Date | null, isFirstDay = true) => {
  if (!value) {
    return value;
  }
  value.setDate(
    isFirstDay
      ? 1
      : new Date(value.getFullYear(), value.getMonth() + 1, 0).getDate()
  );
  return value;
};

const FormMonthYearControl = ({
  areHintsShown,
  control,
  onSubmit,
  onChange,
  onChanged,
}: Props): React.JSX.Element => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <DateInput
      format="MM-YYYY"
      disabled={control.disabled}
      required={control.required}
      readOnly={control.readonly}
      invalid={control.invalid}
      name={control.name}
      value={control.value}
      withClearButton={ClearButtonBehaviour.NONE}
      onSubmit={(value: Date | null) =>
        onSubmit?.(setFirstOrLastDay(value, control.isFirstDay))
      }
      onChange={(value: Date | null) =>
        onChange?.(setFirstOrLastDay(value, control.isFirstDay))
      }
      onChanged={(value: Date | null) =>
        onChanged?.(setFirstOrLastDay(value, control.isFirstDay))
      }
    />
  </FormLabeledInputControl>
);

export default FormMonthYearControl;
